import { render, staticRenderFns } from "./manage-activity-list-item-contents.component.vue?vue&type=template&id=92a21af6&scoped=true&"
import script from "./manage-activity-list-item-contents.component.vue?vue&type=script&lang=ts&"
export * from "./manage-activity-list-item-contents.component.vue?vue&type=script&lang=ts&"
import style0 from "./manage-activity-list-item-contents.component.vue?vue&type=style&index=0&id=92a21af6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a21af6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
